import React from 'react';
import { MessageCircleIcon, LayoutDashboardIcon, FileTextIcon } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    icon: MessageCircleIcon,
    title: 'Kit de Mensajes 3 Niveles (WhatsApp + Email)',
    description: 'Mensajes listos para enviar que hacen que el cliente responda. 30 plantillas para WhatsApp y Email.'
  }, {
    icon: LayoutDashboardIcon,
    title: 'Tablero A4: Control Total (Tracker Mensual + Semáforo)',
    description: 'En 1 hoja A4 sabés quién está al día, quién falta y a quién hay que apretar.'
  }, {
    icon: FileTextIcon,
    title: 'Guía Express: Reglas de Juego (1 Página para Enviar al Cliente)',
    description: 'Instalá límites profesionales sin conflicto. El cliente sabe qué mandar, cuándo y qué pasa si no manda.'
  }];
  return <section id="bonos" className="py-12 bg-[#fcfaf8]" data-id="element-15">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16">
        <h2 className="text-2xl md:text-3xl font-black text-center text-[#1a2e29] mb-8" data-id="element-17">
          Bonos Exclusivos
        </h2>

        <div className="space-y-4 mb-8" data-id="element-18">
          {bonuses.map((bonus, index) => <div key={index} className="bg-[#f4f7f6] rounded-xl border border-[#e5e7eb] p-5 flex items-start gap-4" data-id="element-19">
              <div className="bg-[#fdfbf7] border border-[#e5e7eb] rounded-xl w-14 h-14 flex items-center justify-center flex-shrink-0 shadow-sm" data-id="element-20">
                <bonus.icon className="w-6 h-6 text-[#c69a53]" data-id="element-21" />
              </div>
              <div className="pt-1" data-id="element-22">
                <h3 className="text-[15px] font-bold text-[#1a2e29] mb-1 leading-tight" data-id="element-23">
                  {bonus.title}
                </h3>
                <p className="text-[13px] text-gray-600 leading-snug" data-id="element-24">
                  {bonus.description}
                </p>
              </div>
            </div>)}
        </div>

        <div className="bg-[#fdfbf7] border border-[#e5e7eb] rounded-xl p-6 text-center shadow-sm" data-id="element-25">
          <p className="text-gray-500 font-medium text-[15px] mb-2" data-id="element-26">
            Valor total de los 3 bonos:{' '}
            <span className="line-through" data-id="element-27">$29.990</span>
          </p>
          <div className="flex items-center justify-center gap-2 text-xl md:text-2xl font-bold text-[#c69a53]" data-id="element-28">
            <span data-id="element-29">Por el día de hoy →</span>
            <span className="bg-[#f3e8d5] text-[#c69a53] px-4 py-1 rounded-full text-lg md:text-xl" data-id="element-30">
              GRATIS
            </span>
          </div>
        </div>
      </div>
    </section>;
}